import React from 'react';
import { oneOfType, element, arrayOf, func, bool, string } from 'prop-types';
import { Modal } from '@material-ui/core';

import { Container, Card, Header, Close } from './styles';

function ModalComp({ children, open, onClose, title }) {
  return (
    <Modal 
      className="modal-comp" 
      open={open}
      style={{
        zIndex: 10000, // z-index alto para aparecer acima do mapa e outros elementos
      }}
      BackdropProps={{
        style: {
          zIndex: 9999, // z-index do backdrop
        }
      }}
    >
      <Container>
        <Card>
          <Header>
            {title}
            <Close onClick={onClose} />
          </Header>
          {children}
        </Card>
      </Container>
    </Modal>
  );
}

export default ModalComp;

ModalComp.propTypes = {
  children: oneOfType([element, arrayOf(element)]).isRequired,
  onClose: func,
  open: bool,
  title: string,
};

ModalComp.defaultProps = {
  onClose: () => {},
  open: false,
  title: '',
};
